const translations = {
    acre: 'per acre',
    amountUnitPlaceholder: 'Unit',
    flOz: 'fl oz',
    g: 'g',
    gal: 'gal',
    galWater100: 'per 100 gal water',
    galWater1000: 'per 1,000 gal water',
    ha: 'per hectare',
    kg: 'kg',
    l: 'L',
    lb: 'lb',
    ml: 'mL',
    ozWt: 'oz (wt)',
    perUnitPlaceholder: 'Per',
    pt: 'pt',
    qt: 'qt',
    rateLabel: 'Rate',
    sqFt1000: 'per 1,000 sq ft'
};

export default translations;
